import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { PasswordInput } from "Components/Common/PasswordInput/PasswordInput";
import AuthBody from "Components/Common/AuthBody/AuthBody";
import PopupModal from "Components/Common/PopupModal/PopupModal";

import * as ROUTES from "Constants/Routes";
import STRINGS from "Constants/Strings";
import AppConstants from "Constants/AppConstants";
import VALIDATIONS from "Constants/ValidationList";
import { HTTP_STATUS } from "Communication/Constants";

import { usernameCredentials, isDeviceMobile } from "Utils/CommonUtilities";

import checkErrors from "Utils/InputValidator";

class SignIn extends Component {
  constructor(props) {
    super(props);
    // inputfield error object name  should be inputobject with suffix 'Error'
    //  For example input object: username, input error object: usernameError
    this.state = {
      username: "",
      password: "",
      errors: {
        usernameErrorList: [],
        passwordErrorList: [],
      },
      showPassword: false,
      showModal: false,
      isChecked: false,
      modalType: "",
      modal: {
        title: "",
        description: "",
      },
    };
    this.userNameInput = React.createRef();
  }

  componentDidMount() {
    if (!isDeviceMobile()) {
      this.userNameInput.current.focus();
    }
    if (localStorage.checkbox && localStorage.username !== "") {
      this.setState({
        isChecked: true,
        username: localStorage.username,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { forgotPasswordState } = this.props;

    if (prevProps.forgotPasswordState !== forgotPasswordState) {
      if (
        forgotPasswordState.success &&
        forgotPasswordState.success.status === HTTP_STATUS.OK
      ) {
        if (
          forgotPasswordState.success.data.otpTo ===
          STRINGS.FORGOTPASSWORD.OTP_TO.EMAIL
        ) {
          this.setModalState({
            showModal: true,
            modalType: AppConstants.MODALTYPE.SUCCESS,
            modal: {
              title: STRINGS.FORGOTPASSWORD.MODAL.SUCCESS_MAIL,
              description: "",
            },
          });
        } else {
          this.setModalState({
            showModal: true,
            modalType: AppConstants.MODALTYPE.SUCCESS,
            modal: {
              title: STRINGS.FORGOTPASSWORD.MODAL.SUCCESS_MESSAGE,
              description: "",
            },
          });
        }
      }
    }
  }

  setModalState = (modal) => {
    this.setState(modal);
  };

  toggleModal = () => {
    const { showModal } = this.state;
    this.setState({
      showModal: !showModal,
    });
  };

  handleBack = () => {
    const { history } = this.props;
    history.push(ROUTES.HOME);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { username, password, isChecked } = this.state;
    const { handleSignin } = this.props;
    const errors = this.verifyData();

    if (!errors) {
      const userDetails = {
        credential: usernameCredentials(username),
        password,
        isChecked,
      };
      handleSignin(userDetails);
    }
  };

  handleChecked = () => {
    const { isChecked } = this.state;

    this.setState({
      isChecked: !isChecked,
    });
  };

  forgotPasswordHandler = () => {
    const { history } = this.props;
    history.push(ROUTES.FORGOT_PASSWORD);
  };

  handleRegistration = () => {
    const { history } = this.props;
    history.push(ROUTES.REGISTER);
  };

  changeHandler = (event) => {
    const { errors } = this.state;
    const errorObject = `${event.target?.name}${STRINGS.COMMON.ERROR_LIST}`;
    this.setState({
      [event.target.name]: event.target.value,
      errors: {
        ...errors,
        [errorObject]: [],
      },
    });
  };

  togglePasswordHandler = () => {
    this.setState((prevState) => {
      return { showPassword: !prevState.showPassword };
    });
  };

  verifyData = () => {
    const { username, password, errors } = this.state;

    const usernameErrors = checkErrors(username, VALIDATIONS.SIGNIN.username);

    const passwordErrors = checkErrors(password, VALIDATIONS.SIGNIN.password);
    this.setState({
      errors: {
        ...errors,
        usernameErrorList: usernameErrors,
        passwordErrorList: passwordErrors,
      },
    });

    return usernameErrors.length + passwordErrors.length;
  };

  render() {
    const {
      username,
      password,
      isChecked,
      showModal,
      modalType,
      modal,
      errors,
    } = this.state;
    const { showVaultClicked } = this.props;
    const signInComponent = (
      <form className="[ signin-container ]">
        <div className="[ form-title-signin ]">
          {STRINGS.SIGNIN.VAULTSIGNINTITLE}
        </div>

        <div className="[ form-container ]">
          <div className="[ mb-3 ]">
            <div className="[ form-label ]">
              {STRINGS.SIGNIN.FORM.USERNAMELABEL}
            </div>

            <input
              type="email"
              name="username"
              className={
                errors?.usernameErrorList.length > 0
                  ? "[ form-control ] [ invalid-input ]"
                  : "[ form-control ]"
              }
              placeholder={STRINGS.SIGNIN.FORM.EMAILPLACEHOLDER}
              value={username}
              onChange={this.changeHandler}
              ref={this.userNameInput}
            />
            <div className="[ error-msg ]">{errors?.usernameErrorList[0]}</div>
          </div>

          <div className="[ mb-3 ]">
            <div className="[ form-label ]">
              {STRINGS.SIGNIN.FORM.PASSWORDLABEL}
            </div>
            <PasswordInput
              changeHandler={this.changeHandler}
              password={password}
              passwordError={errors?.passwordErrorList}
              placeholder={STRINGS.SIGNIN.FORM.PASSWORDPLACEHOLDER}
            />
            <div className="[ error-msg ]">{errors?.passwordErrorList[0]}</div>
          </div>

          <div className="[ mb-3 ]">
            <div className="[ row ] [ align-items-center ]">
              <div className="[ col-6 ] [ d-flex align-items-center ] [ checkbox ]">
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={this.handleChecked}
                  id="rememberMeCheckbox"
                />
                <label
                  htmlFor="rememberMeCheckbox"
                  className="[ checkbox-text ]"
                >
                  {STRINGS.SIGNIN.FORM.REMEBERUSERCHECK}
                </label>
              </div>
              <div className="[ col-6 ] [ forgot-link ]">
                <span
                  className="[ link ]"
                  onClick={this.forgotPasswordHandler}
                  role="presentation"
                >
                  {STRINGS.SIGNIN.FORM.FORGOTPASSWORDLINK}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="[ mb-3 ]">
          <div className="[ row ]">
            <div className="[ col-lg-6 ] [ offset-lg-3 ]">
              <button
                type="submit"
                className="[ submit-btn btn ] [ w-100 ]"
                onClick={this.handleSubmit}
              >
                {STRINGS.SIGNIN.FORM.SUBMITBUTTON}
              </button>
            </div>
          </div>
        </div>
      </form>
    );
    const infoContainer = (
      <div className="">
        <div className="[ info-title ]">
          {STRINGS.SIGNIN.INFOCONTAINER.REGISTERTITLE}
        </div>

        <div className="[ mb-3 ]">
          <div className="[ row ]">
            <div className="[ col-lg-6 ] [ offset-lg-3 ] [ col-xl-12 ] [ offset-xl-0 ]">
              <button
                type="button"
                className="[ btn info-btn ] [ w-100 ]"
                onClick={this.handleRegistration}
              >
                {STRINGS.SIGNIN.INFOCONTAINER.REGISTERNAVIGATEBTN}
              </button>
            </div>
          </div>
        </div>

        <div className="[ row ][ info-message ] [ p-3 ]">
          {STRINGS.SIGNIN.INFOCONTAINER.REGISTERNOWINFO1}
        </div>
        <div className="[ version-num ]">{STRINGS.VERSION}</div>
      </div>
    );

    return (
      <>
        {showModal && (
          <PopupModal
            type={modalType}
            title={modal.title}
            description={modal.description}
            toggleModal={this.toggleModal}
            showModal={showModal}
            btnText={STRINGS.POPUPMODAL.OKBUTTON}
          />
        )}
        <AuthBody
          actionComponent={signInComponent}
          infoComponent={infoContainer}
          securityText={STRINGS.INFOBANNER.SECURESESSIONTEXT}
          showVaultClicked={() => showVaultClicked}
          handleBack={this.handleBack}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  signinState: state.SigninReducer,
  forgotPasswordState: state.ForgotPasswordReducer,
});
SignIn.propTypes = {
  forgotPasswordState: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  handleSignin: PropTypes.func,
  history: PropTypes.oneOfType([PropTypes.object]),
  showVaultClicked: PropTypes.func,
};
SignIn.defaultProps = {
  forgotPasswordState: {},
  handleSignin: () => {},
  history: {},
  showVaultClicked: () => {},
};
export default connect(mapStateToProps)(SignIn);
